import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { ISfiCodeRequest, ISfiCodeResponse } from '../models/sfi-code.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class SfiCodeApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/OrderSfiCodeDefinition`;
  }

  constructor(private http: HttpClient) {}

  loadSfiCodes(currentFilter?: MainTableFilterModel): Observable<ApiResponse<ISfiCodeResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<ISfiCodeResponse[]>>(this.url, { params });
  }

  loadAllSfiCodes(): Observable<ISfiCodeResponse[]> {
    const url = `${this.url}/List`;
    return this.http.get<ISfiCodeResponse[]>(url);
  }

  loadAllSfiCodesPerDepartment(): Observable<ISfiCodeResponse[]> {
    const url = `${this.url}/List`;
    const params = new HttpParams().set('DepartmentId', getDepartmentId());
    return this.http.get<ISfiCodeResponse[]>(url, { params });
  }

  loadSfiCodeById(id: string): Observable<ISfiCodeResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<ISfiCodeResponse>(url);
  }

  createSfiCode(sfiCode: ISfiCodeRequest): Observable<ISfiCodeResponse> {
    return this.http.post<ISfiCodeResponse>(this.url, sfiCode, { headers });
  }

  updateSfiCode(sfiCode: ISfiCodeRequest): Observable<ISfiCodeResponse> {
    const url = `${this.url}/${sfiCode.id}`;
    return this.http.put<ISfiCodeResponse>(url, sfiCode, { headers });
  }

  deleteSfiCode(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
